import {DateTime} from "luxon"

export const filialSpecialities = {
  state: {
    allSpecialitiesList: [],
    currentFilialSpecialitiesList: [],
    otherFilialSpecialitiesList: [],
  },
  mutations: {
    setFilialSpecialitiesLists(state, val) {
      state.allSpecialitiesList = val
      let eligibleSpecs = []
      let currentFilialSpecs = []
      let otherSpecs = []

      const defaultFilialId = this.state.filials.defaultFilialId //ID филиала по умолчанию получаем из другого модуля Vuex

      //Сначала формируем список отображаемых элементов
      for (const spec of val) {
        let specX = {
          id: `${spec.specialityId}_${spec.filialId}`,
          specialityId: spec.specialityId,
          name: spec.specialityName,
          closestScheduleDate: DateTime.fromFormat(spec.closestScheduleDate, 'yyyy-MM-dd').toFormat('dd.MM.yyyy'),
          closestScheduleTime: DateTime.fromFormat(spec.closestScheduleTime, 'HH:mm:ss').toFormat('HH:mm'),
          closestScheduleDateTimeIso: `${spec.closestScheduleDate} ${spec.closestScheduleTime}`,
          filialId: spec.filialId,
          availableFilialIdList: [spec.filialId]
        }

        //Ищем в списке элемент с таким же specialityId
        let sameSpecIndex = eligibleSpecs.findIndex(it => it.specialityId === specX.specialityId)
        if (sameSpecIndex === -1) {
          eligibleSpecs.push(specX)
        } else {
          //Если нашли, сравниваем, чьё расписание - ближайшее
          const currentSpecDT = DateTime.fromFormat(specX.closestScheduleDateTimeIso, 'yyyy-MM-dd HH:mm:ss')
          const sameSpecDT = DateTime.fromFormat(eligibleSpecs[sameSpecIndex].closestScheduleDateTimeIso, 'yyyy-MM-dd HH:mm:ss')
          if (defaultFilialId === null) {
            if (currentSpecDT < sameSpecDT) {
              //Текущее расписание - ближайшее. Заменяем элемент внутри массива, добавляя ID филиала из старого элемента в availableFilialIdList
              specX.availableFilialIdList.push(eligibleSpecs[sameSpecIndex].filialId)
              eligibleSpecs[sameSpecIndex] = specX
            } else {
              //Текущее расписание - позже. Добавляем ID филиала текущего элемента availableFilialIdList старого элемента
              eligibleSpecs[sameSpecIndex].availableFilialIdList.push(specX.filialId)
            }
          } else if (specX.filialId === defaultFilialId) {
            //Текущий filialId - тот же, что и по умолчанию.
            //Такое расписание должно быть показано в списке,
            //поэтому заменяем элемент внутри массива, добавляя ID филиала из старого элемента в availableFilialIdList
            specX.availableFilialIdList.push(eligibleSpecs[sameSpecIndex].filialId)
            eligibleSpecs[sameSpecIndex] = specX
          } else {
            //Текущий filialId - не тот, что по умолчанию. Добавляем ID филиала текущего элемента availableFilialIdList старого элемента
            eligibleSpecs[sameSpecIndex].availableFilialIdList.push(specX.filialId)
          }
        }
      }

      //Теперь разделяем список отображаемых элементов на список текущего филиала и список других филиалов
      for (const spec of eligibleSpecs) {
        if (defaultFilialId === null || spec.filialId === defaultFilialId) {
          currentFilialSpecs.push(spec)
        } else {
          otherSpecs.push(spec)
        }
      }

      state.currentFilialSpecialitiesList = currentFilialSpecs
      state.otherFilialSpecialitiesList = otherSpecs
    },
  },
  getters: {
    currentFilialSpecialitiesList(state) {
      return state.currentFilialSpecialitiesList
    },
    otherFilialSpecialitiesList(state) {
      return state.otherFilialSpecialitiesList
    },
  },
  actions: {
    recalculateFilialSpecialities({commit, state}) {
      commit('setFilialSpecialitiesLists', state.allSpecialitiesList)
    }
  }
}